export default __webpack_public_path__ + "images/XW.8a1d306.png";